/**
 * Capitalizes the first letter of a string.
 * @param {string} text The string to capitalize.
 * @returns {string} The string with the first letter capitalized.
 */
export function capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * Filter changes between two arrays
 * @param {T[]} original The original array
 * @param {T[]} selected The selected array
 * @param {(item: T) => number} getId The function to get the ID of an item
 * @returns {{ added: T[], removed: T[] }} The added and removed items
 */
export function filterChanges<T>(original: T[], selected: T[], getId: (item: T) => number) {
    const added = selected.filter(item => !original.some(org => getId(org) === getId(item)));
    const removed = original.filter(org => !selected.some(item => getId(org) === getId(item)));
    return { added, removed };
}

/**
 * Get the associated alpha-2 country code for a given alpha-3 country code.
 * @param {string} alpha3 The alpha-3 country code.
 * @returns {string} The alpha-2 country code.
 */
export function alpha3ToAlpha2(alpha3: string): string {
    const code = alpha3.toLowerCase();
    switch (code) {
        case 'eng':
            return 'gb';
        case 'spa':
            return 'es';
        case 'fra':
            return 'fr';
        case 'por':
            return 'pt';
        case 'ita':
            return 'it';
        case 'deu':
        case 'ger':
            return 'de';
        case 'rus':
            return 'ru';
        case 'cat':
            return 'es-ct';
        case 'ara':
            return 'arab';
        default:
            console.error(`Unknown language code: ${alpha3}`);
            return alpha3.toLowerCase();
    }
}

export function alpha2ToAlpha3(alpha2: string): string {
    const code = alpha2.toLowerCase();
    switch (code) {
        case 'en':
        case 'gb':
            return 'eng';
        case 'es':
            return 'spa';
        case 'fr':
            return 'fra';
        case 'pt':
            return 'por';
        case 'it':
            return 'ita';
        case 'de':
            return 'deu';
        case 'ru':
            return 'rus';
        case 'ca':
        case 'es-ct':
            return 'cat';
        case 'ar':
        case 'arab':
            return 'ara';
        default:
            console.error(`Unknown language code: ${alpha2}`);
            return alpha2.toLowerCase();
    }
}